import { useMutation } from '@tanstack/react-query';
import { insurerDataService } from '../../../Domain/BaselineMeasurements/Services';
import { type UploadInsurerData } from '../../../types/BaselineMeasurements';

type UploadInsurerFileResponseData = {};

const mutationFn = async (data: UploadInsurerData) => {
  const response = await insurerDataService.uploadInsurerEmployeeData(data);
  return response.data;
};

export const useConnectionUploadInsurerDataMutation = () => {
  return useMutation<UploadInsurerFileResponseData, unknown, UploadInsurerData>(mutationFn);
};
